import { render, staticRenderFns } from "./UserRoleListView.vue?vue&type=template&id=628479ae&scoped=true&"
import script from "./UserRoleListView.vue?vue&type=script&lang=ts&"
export * from "./UserRoleListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628479ae",
  null
  
)

export default component.exports